import React from 'react';
import './Benefits.css';
import iconCompetitiveSalary from './images/competitive-salary.svg';
import iconFlexibleSpending from './images/flexible-spending.svg';
import iconMedicalCoverage from './images/medical-coverage.svg';
import iconReferalBonus from './images/referal-bonus.svg';
import iconProfessionalDev from './images/professional-development.svg';
import iconCharitable from './images/charitable.svg';
import iconPlan401 from './images/plan-401.svg';
import iconVolunteers from './images/volunteers-opportunities.svg';
import iconParentalFamily from './images/parental-family.svg';

// @TODO: hard coded content which will need to be refactored for CMS integration
const Benefits = () => {
    return (
        <section className="section benefits-section">
            <div className="container">
                <div className="columns is-mobile is-multiline main-block">
                    <div className="column is-offset-1-tablet is-5-desktop">
                        <div className="big-title font-ff-din-pro color-darkblue">
                            Compensation<br />
                            Benefits &amp;<br />
                            Perks
                        </div>
                        <div className="body-text">
                            <p>We offer our employees comprehensive compensation and benefits packages, as well as programs focused on wellness, community involvement and work-life balance. </p>
                        </div>
                    </div>
                    <div className="column is-12-mobile is-12-tablet is-5-desktop">
                        <div className="icons-wrapper">
                            <div className="columns is-mobile is-multiline">
                                <div className="column is-half-mobile is-4-tablet is-4-desktop">
                                    <div className="iconix">
                                        <span className="helper"></span>
                                        <img src={iconCompetitiveSalary} alt={iconCompetitiveSalary} width="51" height="52"/>
                                    </div>
                                    <div className="bodyCopy">
                                        <span>Competitive Salary</span>
                                    </div>
                                </div>
                                <div className="column is-half-mobile is-4-tablet is-4-desktop">
                                    <div className="iconix">
                                        <span className="helper"></span>
                                        <img src={iconMedicalCoverage} alt={iconMedicalCoverage} width="54" height="56"/>
                                    </div>
                                    <div className="bodyCopy">
                                        <span>Medical, Dental &amp; Vision Coverage</span>
                                    </div>
                                </div>
                                <div className="column is-half-mobile is-4-tablet is-4-desktop">
                                    <div className="iconix">
                                        <span className="helper"></span>
                                        <img src={iconFlexibleSpending} alt={iconFlexibleSpending} width="62" height="48"/>
                                    </div>
                                    <div className="bodyCopy">
                                        <span>Flexible Spending Accounts</span>
                                    </div>
                                </div>
                                <div className="column is-half-mobile is-4-tablet is-4-desktop">
                                    <div className="iconix">
                                        <span className="helper"></span>
                                        <img src={iconPlan401} alt={iconPlan401} width="55" height="47"/>
                                    </div>
                                    <div className="bodyCopy">
                                        <span>401K</span>
                                    </div>
                                </div>
                                <div className="column is-half-mobile is-4-tablet is-4-desktop">
                                    <div className="iconix">
                                        <span className="helper"></span>
                                        <img src={iconParentalFamily} alt={iconParentalFamily} width="62" height="48"/>
                                    </div>
                                    <div className="bodyCopy">
                                        <span>Parental / Family Leave  </span>
                                    </div>
                                </div>
                                <div className="column is-half-mobile is-4-tablet is-4-desktop">
                                    <div className="iconix">
                                        <span className="helper"></span>
                                        <img src={iconProfessionalDev} alt={iconProfessionalDev} width="50" height="30"/>
                                    </div>
                                    <div className="bodyCopy">
                                        <span>Professional Development</span>
                                    </div>
                                </div>
                                <div className="column is-half-mobile is-4-tablet is-4-desktop">
                                    <div className="iconix">
                                        <span className="helper"></span>
                                        <img src={iconReferalBonus} alt={iconReferalBonus} width="34" height="49"/>
                                    </div>
                                    <div className="bodyCopy">
                                        <span>Employee Referral Bonus Program</span>
                                    </div>
                                </div>
                                <div className="column is-half-mobile is-4-tablet is-4-desktop">
                                    <div className="iconix">
                                        <span className="helper"></span>
                                        <img src={iconCharitable} alt={iconCharitable} width="55" height="50"/>
                                    </div>
                                    <div className="bodyCopy">
                                        <span>Charitable Giving Program</span>
                                    </div>
                                </div>
                                <div className="column is-half-mobile is-4-tablet is-4-desktop">
                                    <div className="iconix">
                                        <span className="helper"></span>
                                        <img src={iconVolunteers} alt={iconVolunteers} width="54" height="43"/>
                                    </div>
                                    <div className="bodyCopy">
                                        <span>Volunteer Opportunities</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Benefits;
